import listAppsMetadata from '@/redux/requests/apps/listAppsMetadata.js';
import setAppsMetadataItems from './setAppsMetadataItems.js';

/**
 * Loads the app catalog summary into the store. The request revalidates with the stored ETag, so a
 * catalog already in the store (it is persisted) costs one 304.
 */
const loadAppsCatalog = () => {
  return async (dispatch, getState) => {
    const etag = getState()?.pieve?.appsMetadataEtag || null;
    const listRes = await listAppsMetadata({ etag });

    if (listRes?.success === false) {
      return listRes;
    }

    if (listRes?.data?.notModified) {
      dispatch({ type: 'pieveConfirmAppsMetadataItems' });
      return { success: true };
    }

    dispatch(setAppsMetadataItems({ items: listRes?.data?.items || [], etag: listRes?.data?.etag || null, includesHidden: true }));
    return { success: true };
  };
};

export default loadAppsCatalog;
